import { useState } from "react";
import axios from "axios";
import Loader from "./Loader";
import TagInput from "./TagInput";

const API_BASE_URL = process.env.REACT_APP_TRANSLATION_API_BASE_URL;


export default function FeedbackForm({selectedProduct}) {
  const [form, setForm] = useState({
    wrong_pairs: [],
    too_complex_words: [],
    preserve_english_terms: [],
    gender_error_phrases: [],
    missing_information: "",
  });

  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState("");

  // Add new wrong pair row
  const addWrongPair = () => {
    setForm({ ...form, wrong_pairs: [...form.wrong_pairs, { bad: "", good: "" }] });
  };

  // Update wrong pair input
  const updateWrongPair = (index, key, value) => {
    const newPairs = [...form.wrong_pairs];
    newPairs[index][key] = value;
    setForm({ ...form, wrong_pairs: newPairs });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      wrong_pairs: Object.fromEntries(form.wrong_pairs.map(p => [p.bad.trim(), p.good.trim()])),
      too_complex_words: form.too_complex_words,
      preserve_english_terms: form.preserve_english_terms,
      gender_error_phrases: form.gender_error_phrases.map(p => {
        const [bad, neutral] = p.split("=").map(s => s.trim());
        return { [bad]: neutral };
      }),
      missing_information: form.missing_information ? [form.missing_information.trim()] : []
    };

    //console.log(form)

    try {
      const res = await axios.post(`${API_BASE_URL}feedback/${selectedProduct}`, payload);
      setResponse(res.data.message);
      setForm({
        wrong_pairs: [],
        too_complex_words: [],
        preserve_english_terms: [],
        gender_error_phrases: [],
        missing_information: "",
      });
    } catch (err) {
      setResponse("❌ Failed to submit feedback");
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <div className="border p-4 rounded shadow bg-gray-50">
      <h2 className="text-xl font-bold">📝 Submit Feedback</h2>

      {/* Wrong Pairs */}
      <div>
        <label className="font-semibold block mb-1">Wrong Translations (bad → good)</label>
        {form.wrong_pairs.map((pair, idx) => (
          <div key={idx} className="flex gap-2 mb-2">
            <input
              type="text"
              placeholder="Bad"
              className="flex-1 p-2 border rounded"
              value={pair.bad}
              onChange={(e) => updateWrongPair(idx, "bad", e.target.value)}
            />
            <input
              type="text"
              placeholder="Good"
              className="flex-1 p-2 border rounded"
              value={pair.good}
              onChange={(e) => updateWrongPair(idx, "good", e.target.value)}
            />
          </div>
        ))}
        <button onClick={addWrongPair} className="text-blue-600 underline">+ Add another pair</button>
      </div>

      {/* Too Complex */}
      {/* <div>
        <label className="font-semibold block mb-1">Too Complex Hindi (comma-separated)</label>
        <input
          type="text"
          placeholder="e.g. प्राविधिक, अनुप्रयोग"
          className="w-full p-2 border rounded"
          value={form.too_complex_words.join(", ")}
          onChange={(e) =>
            setForm({ ...form, too_complex_words: e.target.value.split(",").map(w => w.trim()).filter(Boolean) })
          }
        />
      </div> */}

    <TagInput
      label="Too Complex Hindi e.g. प्राविधिक, अनुप्रयोग"
      placeholder="Press Enter or , to add"
      tags={form.too_complex_words}
      setTags={(val) => setForm({ ...form, too_complex_words: val })}
    />


      {/* Preserve English */}
      {/* <div>
        <label className="font-semibold block mb-1">Preserve English Terms (comma-separated)</label>
        <input
          type="text"
          placeholder="e.g. API, Server, Frontend"
          className="w-full p-2 border rounded"
          value={form.preserve_english_terms.join(", ")}
          onChange={(e) =>
            setForm({ ...form, preserve_english_terms: e.target.value.split(",").map(w => w.trim()).filter(Boolean) })
          }
        />
      </div> */}
      <TagInput
        label="Preserve English Terms e.g. API, Server"
        placeholder="Press Enter or , to add"
        tags={form.preserve_english_terms}
        setTags={(val) => setForm({ ...form, preserve_english_terms: val })}
      />


      {/* Gender Errors */}
      {/* <div>
        <label className="font-semibold block mb-1">Gendered Phrases (CSV: bad=neutral)</label>
        <input
          type="text"
          placeholder="e.g. वह गया=वे गए, उसे भेजा गया=उन्हें भेजा गया"
          className="w-full p-2 border rounded"
          value={form.gender_error_phrases.join(", ")}
          onChange={(e) =>
            setForm({ ...form, gender_error_phrases: e.target.value.split(",").map(w => w.trim()).filter(Boolean) })
          }
        />
      </div> */}

      <TagInput
        label="Gender Error Phrases (bad=neutral) e.g. वह गया=वे गए, उसे भेजा गया=उन्हें भेजा गया"
        placeholder="Press Enter or , to add"
        tags={form.gender_error_phrases}
        setTags={(val) => setForm({ ...form, gender_error_phrases: val })}
      />


      {/* Missing Info */}
      <div>
        <label className="font-semibold block mb-1">Missing Information / Notes</label>
        <textarea
          placeholder="Enter any notes on missing context, errors, etc."
          className="w-full p-2 border rounded h-24"
          value={form.missing_information}
          onChange={(e) =>
            setForm({ ...form, missing_information: e.target.value })
          }
        />
      </div>

      {/* Submit */}
      <button
        disabled={loading}
        onClick={handleSubmit}
        className={`px-4 py-2 rounded text-white ${
          loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
        }`}
      >
        {loading ? "Submitting..." : "Submit Feedback"}
      </button>
      {loading && (
        <Loader message="Translating..." />
      )}
      {response && <p className="text-sm mt-2 text-blue-600">{response}</p>}
    </div>
  );
}
